import { motion } from "framer-motion";
import { Leaf } from "lucide-react";
import Swal from "sweetalert2";

export default function About() {
  const handleSubscribe = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "success",
      title: "You're in! 🎉",
      text: "Thanks for subscribing to SuprSkin.",
      confirmButtonColor: "#809080",
    });
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative h-[40vh] bg-cover bg-top md:bg-center"
        style={{
          backgroundImage:
            "url('https://img.freepik.com/free-photo/friends-doing-their-nail-care-routine-together_23-2149297998.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-[#fef8f5] opacity-90" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl font-serif font-bold text-[#7a6e5f]">
            About SuprSkin
          </h1>
        </div>
        <div className="absolute bottom-0 w-full h-16 bg-gradient-to-b from-transparent to-[#fef8f5]" />
      </div>

      {/* Who We Are */}
      <section className="bg-[#fef8f5] py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <Leaf className="w-8 h-8 text-[#809080] mx-auto mb-4" />
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-serif font-bold text-[#7a6e5f] mb-6"
          >
            We're Not Just Another Skincare Brand
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-[#7a6e5f] opacity-80 text-lg leading-relaxed max-w-2xl mx-auto"
          >
            At <span className="font-semibold text-[#809080]">SuprSkin</span>, we believe skincare should feel like self-trust in a bottle. No more guessing. No more one-size-fits-all. We’re here to bring harmony between your skin’s true needs and the earth that nurtures us.
          </motion.p>
        </div>
      </section>

      {/* Mission */}
      <section className="bg-white py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="text-[#7a6e5f]"
          >
            <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
            <p className="opacity-80 text-base leading-loose">
              To deliver gentle yet high-performing skincare tailored to your unique skin type — all while staying rooted in sustainable, ethical practices. We’re obsessed with ingredients that are safe, effective, and always kind to your skin and the environment.
            </p>
          </motion.div>

          <motion.img
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            src="https://www.naturopathy-uk.com/wp-content/uploads/2021/10/make-your-own-natural-skincare.jpeg"
            alt="SuprSkin products"
            className="rounded-xl shadow-lg"
          />
        </div>
      </section>

      {/* Why SuprSkin */}
      <section className="bg-[#fef8f5] py-20 px-6">
        <div className="max-w-4xl mx-auto text-center text-[#7a6e5f]">
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-2xl font-bold mb-6"
          >
            Why SuprSkin?
          </motion.h3>
          <motion.ul
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="space-y-4 text-left text-base opacity-80 leading-relaxed"
          >
            <li>🌿 Formulated for your skin type, not the masses</li>
            <li>♻️ Recyclable packaging & refillable systems</li>
            <li>🐰 Cruelty-free & vegan-friendly</li>
            <li>✨ Created by real skin experts (and real people)</li>
          </motion.ul>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="bg-[#7a6e5f] py-20 px-6 text-white text-center">
        <div className="max-w-lg mx-auto">
          <motion.h3
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl font-serif font-semibold mb-4"
          >
            Join Our Glow Circle
          </motion.h3>
          <p className="opacity-90 mb-6 text-base leading-relaxed">
            Subscribe to receive skincare tips, special offers, and product drops straight to your inbox.
          </p>
          <form
            onSubmit={handleSubscribe}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <input
              type="email"
              placeholder="Your email address"
              className="px-4 py-3 rounded-md text-black w-full sm:w-2/3 focus:outline-none focus:ring-2 focus:ring-[#d6a89e]"
              required
            />
            <button
              type="submit"
              className="bg-white text-[#7a6e5f] font-medium px-6 py-3 rounded-md hover:bg-[#f5eee6] transition"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
